let n;
const t = (o) => {
  n = {
    ...n,
    ...o
  };
}, i = (o) => {
  t(o);
};
export {
  n as config,
  i as initCommonApi,
  t as updateConfig
};
